module.exports = __webpack_public_path__ + "img/career-dots.8f9f7f9d.svg";